import React, { Component } from 'react'
import PropTypes from "prop-types"
import { OnboardingHeader } from "components/OnboardingHeader"
import { InstallLink, trackTeammateInstall } from 'layouts/OnboardingInstallStep/InstallOptions'
import Snippet from 'components/OnboardingInstallSnippet'
import EmailSnippetModal from 'layouts/OnboardingInstallStep/EmailSnippetModal'
import BackButton from "components/OnboardingBackButton"

import './style.css'

class SnippetInstall extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    installType: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = { showInviteModal: false }
  }

  render() {
    const { history, installType, path, name } = this.props
    const { showInviteModal } = this.state

    const stepName = `${name} Snippet Install`

    return (
      <div className="snippet-install-wrapper">
        <OnboardingHeader
          title={`Install Drift with ${installType}`}
          description="Don’t worry — installing Drift won’t make any changes to your site now!"
        />
        <Snippet installType={installType} history={history} path={path} stepName={stepName}/>
        <div className="snippet-install-teammate-help">
          <InstallLink
            text="Need help from a teammate?"
            linkText="Send to a teammate"
            onClick={() => {
              trackTeammateInstall({ stepName })
              this.setState({
                showInviteModal: true
              })
            }}
          />
          <BackButton/>
        </div>
        { showInviteModal ? <EmailSnippetModal onClose={()=> {this.setState({ showInviteModal: false }) }} name={name}/> : null }
      </div>
    )
  }
}

export default SnippetInstall


// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/SnippetInstall/index.js